module.exports = __webpack_public_path__ + "img/demonstrators.cea7639b.jpg";